module.exports = __webpack_public_path__ + "webpc/img/icon_share_4.235d7d57.png";